import { Dialog } from "primereact/dialog";
import { JVInput } from "../../shared/JVInput";
import { Button } from "primereact/button";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { Fetch, baseUrl } from "../../shared/Fetch";
import { useEffect, useState } from "react";
import { IGallery } from "./Table";
import { FileUpload } from "primereact/fileupload";

interface IProps {
    singleData: IGallery,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

const schema = yup.object({
    title: yup.string().required("Title is required"),
});

export const Form = (props: IProps) => {
    const [saveDis, setSaveDis] = useState(false);
    const [loading, setLoading] = useState(false);
    const [image, setImage] = useState(false);
    const [video, setVideo] = useState(false);
    const [isStatus, setIsStatus] = useState(false);



    const { control, handleSubmit, watch, formState: { errors }, reset } = useForm<IGallery>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    const onSubmit = (data: IGallery) => {
        if (video) {
            setSaveDis(true);
            saveToDB(data);
        }
        else {
            props.toast.current.show({ severity: 'error', content: "Please Upload the Video First." });
        }
    }

    const saveToDB = async (data: any) => {
        setLoading(true);
        const method = props.singleData.title != "" ? "PUT" : "POST";
        const message = props.singleData.title != "" ? "Updated Successfully" : "Added Successfully";


        const response = await Fetch("Video_Gallery", method, data, null, props.toast);
        if (response) {
            props.hideDialog();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.setReload(!props.reload);
            setSaveDis(false);
        } else {
            setSaveDis(false);
        }
        setLoading(false);
        setVideo(false);

    }

    const videoUpload = (event: any) => {
        if (event.files[0].type === "video/mp4") {
            // Adjust file type as needed
            if (event.files[0].size > 1024 * 1024 * 100) { // Assuming max size is 100 MB
                console.log(3);
                props.toast.current.show({ severity: 'error', content: "Video file should be less than 100 MB." });
            } else {
                uploadVideo(event.files[0]);
            }
        } else {
            props.toast.current.show({ severity: 'error', content: "Please Choose A MP4 Video File." });
        }
        event.options.clear();
    }
    
    const uploadVideo = async (videoFile: File) => {
        console.log(5);
        // setImageType(image.type.split("/")[1]);
        setLoading(true);
        let formData = new FormData();
        formData.append('video', videoFile);
        const params = {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            },
            body: formData
        };
        const response = await fetch(`${baseUrl}Video_gallery/uploadVideo`, params);
        console.log('response', response);
        if (response) {
            setImage(true);
            setVideo(true);
            props.toast.current.show({ severity: 'success', content: "Vedio Uploaded Successfully." });
        }
        else props.toast.current.show({ severity: 'error', content: "vedio Not Uploaded" })
        setLoading(false);
    }

    const onHide = () => {
        props.hideDialog();
        setVideo(false);
    }

    useEffect(() => {
        reset(props.singleData);
        if (props.singleData.status) {
            setIsStatus(true);
        }
    }, [props.open]);

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "status") {
                if (value.status === true) setIsStatus(true);
                else setIsStatus(false);
            }
        });
        return () => subscription.unsubscribe();
    }, [watch]);

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Video Gallery " modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVInput label='Title' column={3} name='title' control={control} error={errors.title?.message} ></JVInput>
                <JVInput label='Description' column={3} name='description' control={control} ></JVInput>
                <div className="card flex justify-content-center">
                    <FileUpload mode="basic" name="demo" url="/api/upload" accept="video/*" customUpload uploadHandler={videoUpload} />
                </div>
                {/* <JVCheckbox column={1} control={control} name="status" label="Status" /> */}
                <div className="col-12 md:col-12 flex gap-4 mt-4">
                    <Button loading={loading} className="field col md:col" label="SAVE" type="submit" disabled={saveDis} ></Button>
                    <Button className="field col md:col p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
                </div>
            </form>
        </Dialog>
    );
}

